
export const hintUsedPunishment = 30;
export const wrongAnswerPunishment = 30;

export const countDownStartNum= 3600;
export const pointsPerMinuteFasterThanCountDown = 10;
